import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ROUTES } from '../../common/constants';
import Error404 from '../../Error404';
import LibraryStaff from './pages/LibraryStaff';

const LibraryStaffWrapper = () => (
  <Switch>
    <Route exact path={ROUTES?.LIBRARY_STAFF} component={LibraryStaff} />
    <Route path="*" exact component={Error404} />
  </Switch>
);

export default LibraryStaffWrapper;
